(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('SuperBillDetailController', SuperBillDetailController);

    SuperBillDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SuperBill', 'Evaluation', 'Employee', 'InsuranceCarrier', 'InsuranceType', 'InsuranceLevel', 'InsuranceRelation', 'CountryState', 'Chart'];

    function SuperBillDetailController($scope, $rootScope, $stateParams, previousState, entity, SuperBill, Evaluation, Employee, InsuranceCarrier, InsuranceType, InsuranceLevel, InsuranceRelation, CountryState, Chart) {
        var vm = this;

        vm.superBill = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bluebookApp:superBillUpdate', function(event, result) {
            vm.superBill = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
